import styled from '@emotion/styled'
import { LinearProgress } from '@mui/material'

const StyledLinearProgress = styled(LinearProgress)`
  position: absolute;
  top: 0;
  left: 0;
  width: 100%;
`

const PositionedTopProgress = ({ isLoadingDelayed, style, ...rest }) => (
  <StyledLinearProgress
  style={{
    visibility: isLoadingDelayed ? 'visible' : 'hidden',
    ...style
  }}
  {...rest}
  />
)


export { PositionedTopProgress }